// ---------------------------------------------------------------------------
// Inlined from ./r2-image-url.ts
// ---------------------------------------------------------------------------

/**
 * Convert an R2 key to a relative URL path served by the worker's
 * /api/images/raw endpoint. Encodes each path segment.
 */
export const r2KeyToImagePath = (key: string): string => {
  if (!key || key.includes('..')) {
    throw new Error(`Invalid R2 image key: ${key}`);
  }
  return `/api/images/raw/${key.split('/').map(encodeURIComponent).join('/')}`;
};
